import { useQuery } from 'react-query';
import { apiCpService } from '@services/apiCpService.ts';
import { ChargePointMapper } from '@services/mappers/charge-point.mapper.ts';
import { useAppStore } from '@stores/app.store.ts';
import { DATA_REFETCHING_INTERVAL_MS } from '@shared/constants/api.constants.tsx';

export const FindRunningChargePointsQueryKey = 'find-running-charge-points';

export const useFindRunningChargePointsQuery = () => {
  const isLiveDataEnabled = useAppStore(state => state.isLiveDataEnabled);

  return useQuery(
    FindRunningChargePointsQueryKey,
    async () => {
      const { data } = await apiCpService.getRunningChargepointsCpClientChargepointsGet();

      return data.map(item => ChargePointMapper.toChargePoint(item));
    },
    {
      refetchInterval: isLiveDataEnabled ? DATA_REFETCHING_INTERVAL_MS : undefined,
    },
  );
};
